import Reflux from 'reflux';

export default Reflux.createActions({
    "getProveedores": {},
    "getProveedor": {},
    "postProveedor": {},
    "putProveedor": {},
    "filter": {sync: true},
    "getRif": {},
    "apiFilter": {},
    "deleteProveedor": {}
});


/** WEBPACK FOOTER **
 ** ./app-react/reflux/ProveedoresActions.js
 **/